import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import "./reports.css";
import ReactApexChart from "react-apexcharts";

const RevenueChart = ({ quarterlyRevenue }) => {
  const barRef = useRef(null);

  useEffect(() => {
    if (quarterlyRevenue?.length > 0) {
      window.Apex = {
        chart: { foreColor: "#ccc", toolbar: { show: false } },
        stroke: { width: 3 },
        dataLabels: { enabled: false },
        tooltip: { theme: "dark" },
        grid: { borderColor: "#535A6C", xaxis: { lines: { show: true } } },
      };

      const mountChart = (ref, options) => {
        const el = ref.current;
        if (el) {
          const chart = new ApexCharts(el, options);
          chart.render();
        }
      };
      const quarters = quarterlyRevenue.map((m) => m.date);
      const revenueData = [
        {
          name: "countries",
          data: quarterlyRevenue.map((item) => item.countries),
        },
        {
          name: "Provinces",
          data: quarterlyRevenue.map((item) => item.provinces),
        },
        {
          name: "Cities",
          data: quarterlyRevenue.map((item) => item.cities),
        },
      ];
      const optionsBar = {
        chart: { height: 380, type: "bar", stacked: true },
        plotOptions: { bar: { columnWidth: "30%", horizontal: false } },
        series: revenueData,
        // series:[
        //   { name: "Countries", data: [14, 25, 21, 17, 12, 13, 11, 19] },
        //   { name: "Provinces", data: [13, 23, 20, 8, 13, 27, 33, 12] },
        //   { name: "Cities", data: [11, 17, 15, 15, 21, 14, 15, 13] },
        // ],
        xaxis: {
          categories: quarters,
          // categories: [
          //   "2011",
          //   "2011",
          //   "2011",
          //   "2011",
          //   "2012",
          //   "2013",
          //   "2013",
          //   "2013",
          //   "2013",
          // ],
        },
        fill: { opacity: 1 },
      };

      mountChart(barRef, optionsBar);
    }
  }, [quarterlyRevenue]);

  return (
    <div className="col-md-4 col-sm-6 d-flex">
      <div className="box shadow p-4 rounded cardBox text-light w-100 d-flex flex-column">
        <h5 className="text-center fw-bold mb-3">Total Revenue</h5>
        <div className="flex-grow-1 d-flex align-items-end">
          <div id="barchart" ref={barRef} className="w-100"></div>
        </div>
      </div>
    </div>
  );
};

export default RevenueChart;
